import { createFileRoute } from '@tanstack/react-router'
import { VslProjectsSection } from '@/features/vsl/runs/VslProjectsSection'

export const Route = createFileRoute('/_authenticated/vsl/runs')({
  component: VslProjectsSection,
})
